export default __webpack_public_path__ + "static/media/home_new.856e595a.png";